const ComplianceHeader = ({ data }) => {
  const regions = data?.regions || []
  const regionsCount = regions.length
  const suppliersCount = regions.reduce(
    (sum, region) => sum + (region?.suppliers?.length || 0),
    0,
  )

  return (
    <div className="d-flex justify-content-between align-items-center mb-4">
      <div>
        <h5 className="mb-1 fw-semibold">Regional Compliance Overview</h5>
        <p className="text-muted mb-0 small">
          Detailed breakdown of compliance metrics across regions, suppliers,
          and individual members
        </p>
      </div>
      <div className="d-flex gap-4">
        <div className="text-center">
          <div className="small text-muted">Regions</div>
          <div className="fw-bold text-primary h5 mb-0">{regionsCount}</div>
        </div>
        <div className="text-center">
          <div className="small text-muted">Suppliers</div>
          <div className="fw-bold text-info h5 mb-0">{suppliersCount}</div>
        </div>
      </div>
    </div>
  )
}

export default ComplianceHeader
